import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAuthSession } from '@/features/auth/useAuthSession';
import { track } from '@/services/analytics';
import { addFavorite, removeFavorite } from '@/services/favorites';

export function useFavoriteMutations() {
  const { session } = useAuthSession();
  const queryClient = useQueryClient();

  /*
   * И избранное, и экран результата показывают статус «в избранном» —
   * после переключения оба должны перечитать данные, иначе кнопка на
   * экране результата останется в старом состоянии до ручного обновления.
   */
  const invalidate = () => {
    void queryClient.invalidateQueries({ queryKey: ['favorites'] });
    void queryClient.invalidateQueries({ queryKey: ['generation'] });
  };

  const add = useMutation({
    mutationFn: (generationImageId: string) => {
      if (!session) {
        return Promise.reject(new Error('Нет активной сессии.'));
      }

      return addFavorite(session.user.id, generationImageId);
    },
    onSuccess: () => {
      // Событие ставится после успеха: «добавил в избранное» — это факт,
      // а не намерение.
      track('favorite_added');
      invalidate();
    },
  });

  const remove = useMutation({
    mutationFn: (favoriteId: string) => removeFavorite(favoriteId),
    onSuccess: invalidate,
  });

  return { add, remove };
}
